import distance from 'images/year-in-review/2017/backgrounds/community-distance.jpg'
import duration from 'images/year-in-review/2017/backgrounds/community-duration.jpg'
import routes from 'images/year-in-review/2017/backgrounds/community-routes.jpg'

const backgrounds = {
  distance,
  duration,
  routes,
}
export default backgrounds



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Community/communityBackgrounds.js